import { useEffect } from 'react';
import { useAuthRedirect } from '@bridebook/web/app-shared/lib/app/hooks/use-auth-redirect';
import { useParseShowroundQueryParams } from '@bridebook/web/app-shared/lib/app/hooks/use-parse-showround-query-params';

type UseHandleShowroundRedirectOptions = {
  isVenue: boolean;
};

/**
 * Handles showround-related redirection for unauthenticated users.
 *
 * For unauthenticated users: redirects to login with next url in query params so once user is
 * logged in, they are redirected back to the suppliers page and the appropriate action is
 * triggered.
 */
export const useHandleShowroundRedirect = (options: UseHandleShowroundRedirectOptions) => {
  const redirect = useAuthRedirect();
  const { hasSchedulingParams } = useParseShowroundQueryParams();

  useEffect(() => {
    if (options.isVenue && hasSchedulingParams) {
      redirect();
    }
  }, [hasSchedulingParams, options.isVenue, redirect]);
};
